import React from 'react'

export function PayNowArrowIcon() {
  return (
    <svg
      width="18"
      height="15"
      viewBox="0 0 18 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{display: 'block', flexShrink: 0}}
    >
      <path
        d="M11.4019 14.4511C11.4039 14.4491 11.4059 14.4471 11.408 14.445L17.709 8.15221C17.7588 8.10221 17.8029 8.04696 17.8408 7.98746L17.9397 7.80626L17.9809 7.68271L17.9809 7.5921C18.0064 7.45326 18.0064 7.3109 17.9809 7.17202L17.9809 7.08967L17.9809 6.99083L17.9067 6.85079C17.8643 6.77276 17.8117 6.70072 17.7502 6.63662L11.408 0.319084C10.9883 -0.103962 10.3051 -0.106703 9.88203 0.312984C9.87998 0.314991 9.87797 0.317038 9.87593 0.319084C9.46906 0.745527 9.46906 1.41641 9.87593 1.84289L13.6319 5.60706C13.7911 5.76945 13.7885 6.03022 13.6261 6.18945C13.5506 6.26354 13.4494 6.3057 13.3436 6.30717L1.07911 6.30717C0.483169 6.30713 4.92943e-05 6.79017 9.21389e-06 7.38611C-2.89591e-05 7.98205 0.483015 8.46514 1.07895 8.46521L1.07911 8.46521L13.3436 8.46521C13.571 8.46842 13.7528 8.65537 13.7496 8.88278C13.7481 8.98857 13.706 9.08976 13.6319 9.16532L9.87593 12.913C9.46381 13.3406 9.46381 14.0175 9.87593 14.4451C10.2956 14.8681 10.9788 14.8709 11.4019 14.4511Z"
        fill="white"
      />
    </svg>
  )
}
